import { useEffect, useState } from 'react';
import {
  EVENTO_ABRIR_PREFERENCIAS,
  guardarConsentimiento,
  leerConsentimiento,
  type Consentimiento,
} from '../lib/analytics';

// Aviso de cookies discreto: una tarjetita chica abajo a la izquierda, sin tapar el contenido.
// Se muestra en todas las páginas (lo monta src/arranque.tsx).
export default function AvisoCookies() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!leerConsentimiento()) setVisible(true);

    const abrir = () => setVisible(true);
    window.addEventListener(EVENTO_ABRIR_PREFERENCIAS, abrir);
    return () => window.removeEventListener(EVENTO_ABRIR_PREFERENCIAS, abrir);
  }, []);

  const elegir = (valor: Consentimiento) => {
    guardarConsentimiento(valor);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label="Aviso de cookies"
      className="fixed bottom-3 left-3 right-3 z-40 sm:right-auto sm:max-w-xs"
    >
      <div className="rounded-lg border border-neutral-200 bg-white/95 p-3 text-xs text-neutral-600 shadow-md backdrop-blur">
        <p>Uso cookies de análisis (Google Analytics) para mejorar el sitio. No uso publicidad.</p>
        <div className="mt-2 flex justify-end gap-2">
          <button
            type="button"
            onClick={() => elegir('rechazado')}
            className="rounded-md px-2.5 py-1 font-medium text-neutral-600 transition-colors hover:bg-neutral-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
          >
            Rechazar
          </button>
          <button
            type="button"
            onClick={() => elegir('aceptado')}
            className="rounded-md bg-neutral-900 px-2.5 py-1 font-medium text-white transition-colors hover:bg-black focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
}
